<section class="argument-detail-container">
  <claas-app-section-header [isMultiline]="true" [isModalHead]="true">
    <div class="title-subtitle-wrap">
      <h2 class="section-title">
        {{
          $safeNavigationMigration(productArgument()?.Title)
            | stringReplace: "&nbsp;" : " "
        }}
      </h2>
      <p class="font-xs">{{ productArgument()?.Category }}</p>
      <div class="badges">
        @if (productArgument()?.Rating) {
          <div
            [ngClass]="{
              'badge font-3xs': true,
              'is-positive': productArgument()!.Rating! > 0,
              'is-negative': productArgument()!.Rating! < 0,
            }"
          >
            {{
              `features.productArguments.${
                productArgument()!.Rating! > 0
                  ? "positive"
                  : productArgument()!.Rating! < 0
                    ? "negative"
                    : "neutral"
              }`
                | translate
                | uppercase
            }}
          </div>
        }
        @if (productArgument()?.Exclusive) {
          <div class="badge font-3xs">
            {{
              "features.productArguments.exclusiveFlag" | translate | uppercase
            }}
          </div>
        }
      </div>
    </div>

    <div class="app-section-controls">
      @if (!isCompetitor()) {
        <div class="favorite-btn-wrap">
          <button
            (click)="handleFavoriteClick(productArgument()?.ID ?? '')"
            type="button"
            class="favorite-btn icon-only-button small"
            [ngClass]="[isFavourite() ? 'blacken' : '']"
          >
            <claas-icon
              [id]="''"
              [iconId]="'649123'"
              [namespace]="'storybook'"
              [iconStyle]="'bold'"
              [size]="24"
              [alt]=""
              [iconName]="'favorites'"
              [removeDefaultColor]="true"
              [class]="'favorites-icon'"
            >
            </claas-icon>
          </button>
        </div>
      }

      <a
        [routerLink]="
          !currentUrl.includes('comparison')
            ? `/pia/${countryID()}/${languageID()}/${year()}/product/${productSeriesID()}/arguments/${productID()}`
            : `/pia/${countryID()}/${languageID()}/${year()}/product/${productSeriesID()}/arguments/${productID()}/comparison/${competitorID()}`
        "
        [title]="
          'pia.features.product-overview.productFamilyAside.closeFilterButtonLabel'
            | translate
        "
        class="close-button icon-only-button small"
        (click)="handleCloseArgumentDetailDialog()"
      >
        <claas-icon
          [iconId]="'006172'"
          [namespace]="'pia'"
          [size]="24"
          [alt]="''"
          [removeDefaultColor]="true"
        ></claas-icon>
      </a>
    </div>
  </claas-app-section-header>
  <div class="text-image-wrap">
    <div
      class="rich-text"
      [innerHTML]="$safeNavigationMigration(productArgument()?.Detail)"
    ></div>
    @if (productArgument()?.AssetLink) {
      <img
        class="argument-image"
        [src]="
          config.piaAPIOrigin +
            '/' +
            $safeNavigationMigration(productArgument()?.AssetLink) | authImage
        "
        alt=""
      />
    }
  </div>
</section>
